import React from "react"
import { TRIP_TUBS_BUTTON_TYPES } from "../../utils/variables/search"
import TripButton from "./TripButton"
import {
  selectAviaSearchDates,
  setAviaSearchParams,
} from "../../../../../app/reducers/book/aviaSearchSlice"
import { useDispatch, useSelector } from "react-redux"

const TripTypeTabs = () => {
  const dispatch = useDispatch()
  const dates = useSelector(selectAviaSearchDates)

  const handleTripType = () => {
    const isRoundTrip = dates.round_trip

    dispatch(setAviaSearchParams({ key: "dates.round_trip", value: !isRoundTrip }))
    dispatch(setAviaSearchParams({ key: "dates.one_way", value: isRoundTrip }))

    if (isRoundTrip) {
      dispatch(setAviaSearchParams({ key: "dates.to", value: null }))
    }
  }

  return (
    <div className="text-xs bg-white gap-0.5 rounded-md w-auto self-start flex p-0.5">
      {TRIP_TUBS_BUTTON_TYPES.map((btn) => {
        const { key } = btn

        const isActive = dates[key]
        return <TripButton key={key} item={btn} isActive={isActive} onClick={handleTripType} />
      })}
    </div>
  )
}

export default TripTypeTabs
